import { UpsellGuard } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'
import { useFormContext } from '../../../../../../../../hooks'
import type { InvoicingSettingsSection } from '../../../../../../enums/invoicingSettingsSection'
import { useTrackInvoicingSettings } from '../../../../../../hooks/useTrackInvoicingSettings'
import type { LogoAndBrandingSettingsFormSchema } from '../../../../types/logoAndBrandingSettingsFormSchema'
import { FontSelect } from '../../../FontSelect'

interface DefaultFontSelectorProps {
  trackingSection?: InvoicingSettingsSection
}

export const DefaultFontSelector = ({ trackingSection }: DefaultFontSelectorProps): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings({ section: trackingSection })
  const { FormItem } = useFormContext<LogoAndBrandingSettingsFormSchema>()

  return (
    <FormItem
      name="templateFont"
      label={t('external_invoices.appearance_settings.modal.default_font')}
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <UpsellGuard scope={Scope.InvoiceDesignerUpsell} trackingContext={TrackingContext.InvoiceDesigner}>
            <FontSelect
              {...props}
              defaultSelectedId={value}
              dropdownSize="fitTrigger"
              onSelect={(id?: string) => {
                onChange?.(id)
                trackInvoicingSettings('Font selected', { font: id })
              }}
              selectedId={value}
            />
          </UpsellGuard>
        )
      }}
    />
  )
}
